import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function CompanyProfile() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/companies/me").then(r => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const payload = { ...data };
      delete payload.id; delete payload.user_id; delete payload.created_at; delete payload.updated_at;
      if (payload.founding_year) payload.founding_year = parseInt(payload.founding_year);
      await api.put("/companies/me", payload);
      toast.success("Profilo aggiornato");
    } catch (e) { toast.error("Errore salvataggio"); }
    finally { setSaving(false); }
  };

  if (loading) return <Loader2 className="animate-spin text-slate-400" />;

  return (
    <div className="max-w-3xl">
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Profilo aziendale</h1>
      <p className="text-sm text-slate-600 mb-6">Mantieni aggiornate le informazioni della tua azienda.</p>
      <div className="cxo-card p-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Field label="Ragione sociale"><Input value={data.company_name || ""} onChange={e => setData({...data, company_name: e.target.value})} /></Field>
        <Field label="Settore"><Input value={data.sector || ""} onChange={e => setData({...data, sector: e.target.value})} /></Field>
        <Field label="Dipendenti">
          <Select value={data.size_employees || ""} onValueChange={v => setData({...data, size_employees: v})}>
            <SelectTrigger><SelectValue placeholder="Seleziona" /></SelectTrigger>
            <SelectContent>{["1-10","11-20","21-30","31-40","41-50","51-70","71-100","101-200","201+"].map(r => <SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent>
          </Select>
        </Field>
        <Field label="Fascia di fatturato">
          <Select value={data.revenue_range || ""} onValueChange={v => setData({...data, revenue_range: v})}>
            <SelectTrigger><SelectValue placeholder="Seleziona" /></SelectTrigger>
            <SelectContent>{["<1M","1-5M","5-10M","10-25M","25-50M",">50M"].map(r => <SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent>
          </Select>
        </Field>
        <Field label="Anno fondazione"><Input type="number" value={data.founding_year || ""} onChange={e => setData({...data, founding_year: e.target.value})} /></Field>
        <Field label="Sito web"><Input value={data.website || ""} onChange={e => setData({...data, website: e.target.value})} /></Field>
        <Field label="Città"><Input value={data.city || ""} onChange={e => setData({...data, city: e.target.value})} /></Field>
        <Field label="Regione"><Input value={data.region || ""} onChange={e => setData({...data, region: e.target.value})} /></Field>
        <Field label="Ruolo referente"><Input value={data.contact_role || ""} onChange={e => setData({...data, contact_role: e.target.value})} /></Field>
        <Field label="Descrizione" className="sm:col-span-2"><Textarea rows={3} value={data.description || ""} onChange={e => setData({...data, description: e.target.value})} /></Field>
        <div className="sm:col-span-2 flex flex-wrap gap-4">
          <label className="flex items-center gap-2 text-sm"><Checkbox checked={!!data.is_family_business} onCheckedChange={v => setData({...data, is_family_business: !!v})} /> Azienda familiare</label>
          <label className="flex items-center gap-2 text-sm"><Checkbox checked={!!data.is_startup} onCheckedChange={v => setData({...data, is_startup: !!v})} /> Startup</label>
          <label className="flex items-center gap-2 text-sm"><Checkbox checked={!!data.is_scaleup} onCheckedChange={v => setData({...data, is_scaleup: !!v})} /> Scale-up</label>
        </div>
      </div>
      <Button onClick={save} disabled={saving} className="mt-4 bg-[#2D6BFF] text-white">{saving && <Loader2 size={14} className="mr-2 animate-spin" />} Salva</Button>
    </div>
  );
}

const Field = ({ label, children, className = "" }) => (
  <div className={className}><Label className="mb-1.5 block">{label}</Label>{children}</div>
);
